<template>
  <div class="main-content">
    <div class="page-header">
      <h3 class="page-title">Kardex</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">Productos</a>
        </li>
        <li class="breadcrumb-item active">Kardex</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-header">
        <div class="form-group">
            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Nombre del producto</strong> </label>
                <p v-text="product.name"/>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label><strong>Estado</strong> </label>
                <br>
                <span v-if="product.state==1" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Desactivado</span>
              </div>
            </div>

        </div>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <div class="col-md-6">
            <div class="input-group">
                <input type="text" v-model="search" @keyup="fetchData(1,product.id, search)"  class="form-control" placeholder="Ingrese el numero de venta">
                <button type="submit" @click="fetchData(1,product.id,search)" class="btn btn-theme"><i class="icon-fa icon-fa-search"></i> Buscar</button>
            </div>
          </div>
        </div>
        <table class="table table-responsive">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Estado</th>
              <th>Fecha de registro</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="products in productsArray" :key="products.id">
              <td v-text="products.name"></td>
              <td>
                <span v-if="products.state==1" class="btn btn-success btn-sm">Activo</span>
                <span v-else class="btn btn-danger btn-sm">Desactivado</span>
              </td>
              <td v-text="products.created_at"></td>
              <td>
                <template>
                  <div class="table__actions">
                    <button v-tooltip.top-center="'Editar medida'" class="btn btn-theme btn-block" @click="openModal('update', products)"><i class="icon-fa icon-fa-pencil"/></button>
                    <a/>
                    <!-- Preguntar si se deja editar y desactivar escrito o solo los iconos -->
                    <button v-tooltip.top-center="'Desactivar medida'" v-if="products.state==1" class="btn btn-danger btn-block" @click="openModal('deactivate', products)"><i class="icon-fa icon-fa-trash"/></button>
                    <button v-tooltip.top-center="'Activar medida'" v-else class="btn btn-info btn-block" @click="openModal('activate', products)"><i class="icon-fa icon-fa-check"/></button>
                  </div>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
        <!--Paginación de tabla-->
        <div class="card">
            <div class="card-body">
                <ul class="pagination pagination-primary m-b-0">
                    <li class="page-item" v-if="pagination.current_page > 1">
                        <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page - 1, search)"><i class="icon-fa icon-fa-angle-left"></i></a>
                    </li>
                    <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                        <a class="page-link" href="#" @click.prevent="changePage(page, search)" v-text="page"></a>
                    </li>
                    <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                        <a class="page-link" href="#" @click.prevent="changePage(pagination.current_page + 1, search)"><i class="icon-fa icon-fa-angle-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
      </div>

    </div>
  </div>
</template>


<script>
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import { required, sameAs, minLength, between } from "vuelidate/lib/validators";
import ladda from "ladda";
import MaskedInput from 'vue-text-mask'
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  components: {
    SweetModal,
    SweetModalTab,
    MaskedInput
  },
  props: {
    product: {
      type: Object
    }
  },
  data () {
    return {
      productsArray: [],
      id: 0,
      idproduct: 0,
      tipoAccion: 0,
      equal: '',
      pagination: {
        'total': 0,
        'current_page': 0,
        'per_page': 0,
        'last_page': 0,
        'from': 0,
        'to': 0
      },
      offset: 3,
      search: '',
      mask_quetzal: createNumberMask({
        prefix: 'Q ',
        suffix: '',
        includeThousandsSeparator: true,
        thousandsSeparatorSymbol: ',',
        allowDecimal: true,
        decimalSymbol: '.',
        decimalLimit: 2, // how many digits allowed after the decimal
        integerLimit: 10, // limit length of integer numbers
        allowNegative: false,
        allowLeadingZeroes: false
      }),
    }
  },
  validations: {
    equal: {
      required,
      minLength: minLength(4)
    },
  },
  computed: {
    isActived: function () {
      return this.pagination.current_page
    },
    pagesNumber : function(){
        if(!this.pagination.to){
            return [];
        }
        var from = this.pagination.current_page - this.offset;
        if(from < 1){
            from = 1;
        }
        var to = from + (this.offset * 2);
        if(to >= this.pagination.last_page)
        {
            to = this.pagination.last_page;
        }
        var pagesArray = [];
        while(from <= to){
            pagesArray.push(from);
            from++;
        }
        return pagesArray;
    },
  },
  mounted () {
    this.productnull()
  },
  methods: {
    changePage (page, search) {
      let me = this
      // Actualiza la página actual
      me.pagination.current_page = page
      // Envia la petición para visualizar la data de esa página
      me.fetchData(page, me.product.id, this.search)
    },
    async fetchData (page, id, search) {
      let me = this
      const response = await axios.get(
        `/api/admin/products/kardex?page=${page}&id=${id}&search=${search}`
      )
        .then(function (response) {
          var respuesta = response.data
          me.productsArray = respuesta.products.data
          me.pagination = respuesta.pagination
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    openModal(accion, data = []) {
      let me = this;
      switch (accion) {
        case "register": {
          me.$refs.medida_modal.open();
          this.tituloModal = "Nueva submedida";
          this.equal = "";
          this.id=0;
          this.tipoAccion = 1;
          break;
        }
      }
    },
    closeModal() {
      this.$v.$reset();
      this.name = "";
      this.id=0;
      this.fetchData(this.pagination.current_page, this.product.id, this.search);
    },

    validarTecla: function(e) {
      if (e.keyCode === 13) {
        if(this.tipoAccion===1)
        {
          this.saveDetails();
        }
        else if(this.tipoAccion===2)
        {
          this.updateDetails();
        }
      } else if (e.keyCode === 50) {
        console.log('@ was pressed');
      }
    },
    productnull () {
      if (this.product == undefined) {
        this.$router.push({name: 'Productos'
        })
      } else {
        this.fetchData(1, this.product.id, this.search)
        this.idproduct=this.product.id
      }

    },
    formatQuetzales (amount) {
      var num = parseFloat(amount), formatted
      formatted =  num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
      return amount = 'Q ' + formatted
    },
    converMaskToNumberxd (number) {
      var myNumber = ''
      for (var i = 0; i < number.length; i += 1) {
        if (number.charAt(i) === 'Q' || number.charAt(i) === ',' || number.charAt(i) === ' ') {
          continue
        } else {
          myNumber += number.charAt(i)
        }
      }
      return parseFloat(myNumber).toFixed(2)
    },
  }
}
</script>
<style>
.error {
  color: #dc3545;
}
.imgRedondo {
  width: 150px !important;
  height: 150px !important;
}
</style>



// WEBPACK FOOTER //
// resources/js/views/admin/products/Kardex.vue